// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar-module--navbar--2vo2U","navbar__inner":"Navbar-module--navbar__inner--3TWqD"};